module.exports = __webpack_public_path__ + "static/mobilevikings-logo-0600a2426dacaeaeaa0e034072d59cf4.svg";